export default __webpack_public_path__ + "static/media/logo.c512e028.svg";